import BasePerimeter from './BasePerimeter';

export default new BasePerimeter({
  purpose: 'subject',

  can: {
    all() {
      return this.hasPermission('subject-read');
    },

    create() {
      return this.hasPermission('subject-write');
    },

    read() {
      return this.hasPermission('subject-read');
    },

    update(subject) {
      return this.hasPermission('subject-update') || this.isCreator(subject);
    },

    destroy() {
      return this.hasPermission('subject-delete');
    },

    copy() {
      return this.hasPermission('subject-write');
    },

    addSource() {
      return this.hasPermission('subject-write');
    },

    addLimitation() {
      return this.hasPermission('subject-write');
    },

    matrix() {
      return this.hasPermission('export-matrix');
    }
  },

  isCreator(subject) {
    if (!subject) return false;

    return this.child.id === subject.child_id;
  },

  expose: ['isAdmin']
});
